const urls = {
    BASEURL_DEV: 'https://www.zisonai.com', //定义测试环境下的url
    // BASEURL_DEV: 'http://192.168.0.14:81',
    // BASEURL_DEV : 'http://192.168.0.112:81', //定义测试环境下的url
    // BASEURL_DEV : 'http://192.168.0.188:81', //定义测试环境下的url
    BASEURL_PRO: '', //用于定义生产环境下的url
}

export default urls.BASEURL_DEV;